import { states } from './states';

const provinces: Record<string, string> = {
  AB: 'Alberta',
  BC: 'British Columbia',
  MB: 'Manitoba',
  NB: 'New Brunswick',
  NL: 'Newfoundland and Labrador',
  NS: 'Nova Scotia',
  NT: 'Northwest Territories',
  NU: 'Nunavut',
  ON: 'Ontario',
  PE: 'Prince Edward Island',
  QC: 'Quebec',
  SK: 'Saskatchewan',
  YT: 'Yukon',
};

export const schoolRegions: Record<string, string> = {
  ...states,
  ...provinces,
};
export const countryForRegion = (region: string): 'CA' | 'US' =>
  Object.prototype.hasOwnProperty.call(provinces, region) ? 'CA' : 'US';

export const schoolCountries = [
  { value: 'US', label: '🇺🇸 United States' },
  { value: 'CA', label: '🇨🇦 Canada' },
];

export const regionsForCountry = (country: string) =>
  Object.entries(schoolRegions)
    .filter(([region]) => countryForRegion(region) === country)
    .map(([value, label]) => ({ value, label }));
